export default function ShowWhen({ when, children, otherwise = null }) {
    return when ? children : otherwise;
}
